// extracted by mini-css-extract-plugin
module.exports = {"scrollableWrapper":"Scrollable_scrollableWrapper__f1OOs","scrollableHeader":"Scrollable_scrollableHeader__AjlR_","scrollableContainer":"Scrollable_scrollableContainer__aRYqV"};